import BaseAPI, { querySuffix } from "./BaseAPI";
import { deliveryRoute } from "../routes";

export default class DeliveryAPI extends BaseAPI {
    constructor(emitterInstance) {
        super(emitterInstance, deliveryRoute, "delivery");
    }

    async ListAggregatedByStock(params = {}) {
        return this._request("get", this._url(querySuffix({ aggregate: "by-stock", ...params })));
    }

    async MarkOutOfStock(id) {
        const result = await this._request("put", this._url(`/${id}/out-of-stock`));
        this._emit("mark-out-of-stock", id);
        return result;
    }

    async MarkArchived(id) {
        const result = await this._request("put", this._url(`/${id}/archive`));
        this._emit("mark-archived", id);
        return result;
    }

    async UnmarkArchived(id) {
        const result = await this._request("delete", this._url(`/${id}/archive`));
        this._emit("unmark-archived", id);
        return result;
    }

    async MarkRecalled(id) {
        const result = await this._request("put", this._url(`/${id}/recall`));
        this._emit("mark-recalled", id);
        return result;
    }
}
